module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.html
// module id = o9sb
// module chunks = 0